import { Environment as EnvironmentEnum } from '@gea/digital-ui-lib';
// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const ip = 'smartfiltration-api-test.npe-digital-products.apps.dev.gea.com';

export const environment = {
  name: EnvironmentEnum.PROD,
  production: true,
  apiUrlHistorian: `https://${ip}`,
  clientId: '5528a443-fd33-4d76-91fd-e953ada99b14',
  subscriptionKey: '',
  redirectUri: 'https://smartfiltration.digital.tst.gea.com/',
  postLogoutRedirectUri: 'https://smartfiltration.digital.tst.gea.com/',
  portalUrl: 'https://portal.uat.gea.com/',
  baseUrl: 'https://api.apps.uat.gea.com/',
  authority: 'https://login.portal.uat.gea.com/geaiduat.onmicrosoft.com/b2c_1_signin_signup',
  authorityDomain: 'login.portal.uat.gea.com',
  interceptorURLs: ['https://api.apps.uat.gea.com/'],
  storageURL: "https://content.apps.uat.gea.com/strg-container-b2c/",
  localizationStorageURL: "https://content.apps.uat.gea.com/strg-container-i18n/",
  iconStorageURL: "https://content.apps.uat.gea.com/strg-container-apps/core/portal/icons/",
  appContentStorageURL: "https://content.apps.uat.gea.com/strg-container-apps/",
  passwordResetAuthority: "https://login.portal.uat.gea.com/geaiduat.onmicrosoft.com/B2C_1_RESET_PASSWORD_BY_EMAIL_VERIFICATION",//TAKE FROM BLUEPRINT FOR THE REST OF THE FILES
  coreServiceBaseURL: "https://api.apps.uat.gea.com/",
  portal: {
    redirectURL: "https://portal.uat.gea.com/"
  },
  support: {
    redirectURL: "https://support.apps.uat.gea.com/"
  },
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */

// import 'zone.js/plugins/zone-error';
// Included with Angular CLI.
